export const PrimaryBar = ({ children }) => (
  <div
    data-testid="primary-bar"
    className="fixed inset-x-0 bottom-[calc(56px+var(--safe-bottom))] z-20 border-t border-ax-border bg-ax-bg px-4 py-3 md:static md:mt-6 md:border-0 md:bg-transparent md:p-0"
  >
    {children}
  </div>
);
